import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { ApiException, CreateVendorScoreCardSurveyDataDTO, VendorScoreCardOverviewDTO, VendorScoreCardSurveyClient } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class VendorScoreCardSurveyService {

  constructor(
    private vendorScoreCardSurveyClient: VendorScoreCardSurveyClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) { }

  public addRecord(data: CreateVendorScoreCardSurveyDataDTO): Observable<any> {

    this.spinnerService.show();

    return this.vendorScoreCardSurveyClient
      .createVendorScoreCardSurveyData(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.vendor-score-card.messages.survey-filled-successfully-title',
            'i18n.domain.vendor-score-card.messages.survey-filled-successfully-message'
          );
        }),
        finalize(() => this.spinnerService.hide()),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError(
              'i18n.errors.server-error.title',
              error,
              null,
              ErrorType.serverError
            );
          }
          return throwError(() => error);
        })
      );
  }


  public getVendorScoreCardByAccessToken(accessToken: string): Observable<VendorScoreCardOverviewDTO> {
    this.spinnerService.show();
    return this.vendorScoreCardSurveyClient.getVendorScoreCardByAccessToken(accessToken)
      .pipe(
        finalize(() => this.spinnerService.hide()),
        catchError((error: any) => {
          this.spinnerService.hide();
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            if (!ApiException.isApiException(error)) {
              this.toastService.showError('i18n.errors.server-error.title', error, null, ErrorType.serverError);
            }
            return throwError(() => error);
          }
          return throwError(() => error);
        })
      );

  }
}